import apiClient from '../lib/apiClient';

const clientService = {
  // Get all clients
  getClients: async (filters = {}) => {
    try {
      const result = await apiClient.get('/clients', filters);
      return result;
    } catch (error) {
      return { 
        success: false, 
        error: error.message || 'Failed to fetch clients' 
      };
    }
  },

  // Get client by ID
  getClient: async (clientId) => {
    try {
      const result = await apiClient.get(`/clients/${clientId}`);
      return result;
    } catch (error) {
      return { 
        success: false, 
        error: error.message || 'Failed to fetch client details' 
      };
    }
  },

  // Create new client
  createClient: async (clientData) => {
    try {
      const result = await apiClient.post('/clients', clientData);
      return result;
    } catch (error) {
      return { 
        success: false, 
        error: error.message || 'Failed to create client' 
      };
    }
  },

  // Update client
  updateClient: async (clientId, clientData) => {
    try {
      const result = await apiClient.put(`/clients/${clientId}`, clientData);
      return result;
    } catch (error) {
      return { 
        success: false, 
        error: error.message || 'Failed to update client' 
      };
    }
  },

  // Delete client
  deleteClient: async (clientId) => {
    try {
      const result = await apiClient.delete(`/clients/${clientId}`);
      return result;
    } catch (error) {
      return { 
        success: false, 
        error: error.message || 'Failed to delete client' 
      };
    }
  }
};

export default clientService;

